import { networkActions } from '../../network/actions';

const actions = {
  ...networkActions('flexible/show'),
};

function show(id) {
  return {
    type: actions.LOAD,
    payload: {
      id,
    },
  };
}

function reset() {
  return {
    type: actions.RESET,
  };
}

export { actions, show, reset };
